<!--
HACCP情報CSV出力画面
-->

<template>
  <div>
    <div class="ml-2 mt-12 text-h5">{{ title }}</div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <v-container style="max-width: 800px">
      <v-row
        v-for="input in inputs"
        :key="input.key"
        no-gutters
        dense
        class="mb-2"
      >
        <v-col cols="3">
          <v-subheader class="title mr-2" style="height: 100%"
            >{{ input.title
            }}<v-icon class="ml-1 mb-3 red--text caption" v-if="input.required"
              >mdi-asterisk</v-icon
            ></v-subheader
          ></v-col
        >
        <v-col cols="7" style="margin-left: 12px" v-if="input.key == 'name'">
          <p
            style="text-align: left; top: 10px; position: relative"
            class="text-h6"
          >
            {{ userName }}
          </p>
        </v-col>

        <v-col cols="4" v-if="input.key == 'outputDate'">
          <custom-date-picker
            :dateSub="dateStart"
            :events="events"
            :minDate="minDate"
            :defaultFocus="defaultFocus"
            @on-update-registration-date="selectStartDate"
            @on-update-calendar-month="updateCalendarEvent"
          ></custom-date-picker>
        </v-col>

        <v-col
          cols="1"
          class="text-h5"
          style="
            text-align: center;
            font-size: 50px;
            margin-top: 24px;
            padding: 0px;
          "
          v-if="input.key == 'outputDate'"
        >
          ～
        </v-col>

        <v-col cols="4" v-if="input.key == 'outputDate'">
          <custom-date-picker
            :dateSub="dateEnd"
            :events="events"
            :minDate="minDate"
            @on-update-registration-date="selectEndDate"
            @on-update-calendar-month="updateCalendarEvent"
          ></custom-date-picker>
        </v-col>
      </v-row>
    </v-container>
    <v-container style="max-width: 800px">
      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn color="primary" class="ma-2" width="200" @click="download"
            >ダウンロード</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CustomDatePicker from "../../components/record-update/custom-date-picker.vue";
import Api from "@/logic/api/api.js";
import DateWrapper from "../../logic/common/date-wrapper";
import Alert from "../../components/common/alert.vue";
import AlertBuilder from "../../logic/common/alert-contents";
import valueMapper from "../../logic/common/value-mapper";

export default {
  components: {
    "custom-date-picker": CustomDatePicker,
    alert: Alert,
  },
  data() {
    this.$nextTick(() => {});

    // カレンダーが選択できる最小の日付
    this.minDate = "2021-10-01";
    // 登録対象日_開始日(システム上の最古日を設定)
    this.dateStart = "2021-10-01";
    // 登録対象日_終了日
    var today = new Date();
    var nowYear = today.getFullYear();
    var nowMonth = ("00" + (today.getMonth() + 1)).slice(-2);
    var nowDay = ("00" + today.getDate()).slice(-2);
    this.dateEnd = nowYear + "-" + nowMonth + "-" + nowDay;
    // フォーカスの初期値
    const now = new DateWrapper(Date.now()).format;
    this.defaultFocus = now.systemDate;

    // URLからuidを取得
    if (this.$route.params.name) {
      // ユーザー名(指定ユーザー)
      this.userName = this.$route.params.name;
    }
    if (this.$route.params.uid) {
      // uid(指定ユーザー)
      this.uid = this.$route.params.uid;
    }

    this.title = "生産記録CSV出力";

    // 画面に表示する入力欄を定義する
    let inputs = [];
    // ユーザー名
    inputs.push({
      key: "name",
      title: "ユーザー名",
    });
    // 出力期間
    inputs.push({
      key: "outputDate",
      title: "出力期間",
    });
    // CSVファイル格納URL
    this.csvFileUrl = "";

    return {
      events: {},
      errors: [],
      inputs: inputs,
    };
  },
  methods: {
    /**
     * 出力期間_開始日を画面から取得する
     */
    selectStartDate(selectDate) {
      // API指定用登録日
      this.dateStart = selectDate.replace(/-/g, "/");
    },
    /**
     * 出力期間_終了日を画面から取得する
     */
    selectEndDate(selectDate) {
      // API指定用登録日
      this.dateEnd = selectDate.replace(/-/g, "/");
    },
    /**
     * 登録用送信データを画面から取得する
     */
    buildGetcsvData() {
      var uid = [];
      uid.push(this.uid);
      return {
        user_id: uid,
        record_date_start: this.dateStart.replace(/-/g, "/"),
        record_date_end: this.dateEnd.replace(/-/g, "/"),
      };
    },
    /**
     * 対象ファイルをダウンロードする
     */
    // async downloadCsv() {
    //   const response = await fetch(this.csvFileUrl);
    //   const blob = await response.blob();
    //   const newBlob = new Blob([blob]);
    //   const objUrl = window.URL.createObjectURL(newBlob);
    //   const link = document.createElement("a");
    //   link.href = objUrl;
    //   link.download = this.targetFileName;
    //   link.click();
    //   //   For Firefox it is necessary to delay revoking the ObjectURL.
    //   setTimeout(() => {
    //     window.URL.revokeObjectURL(objUrl);
    //   }, 250);
    // },
    downloadCsv() {
      const url = this.csvFileUrl;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.download = this.targetFileName;
      a.href = url;
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },
    /**
     * 作業・生産情報CSV取得
     */
    download() {
      // CSV取得
      let updateUrl = "";
      let postData = null;
      this.clearMessage();

      // 日付の相関チェック
      if (
        this.dateEnd.replace(/\//g, "-") < this.dateStart.replace(/\//g, "-")
      ) {
        this.showMessage(
          AlertBuilder.error("出力期間が正しく指定されていません")
        );
        return;
      }

      updateUrl = "/haccp/getcsv";
      postData = this.buildGetcsvData();

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
        .then((result) => {
          // ファイル名を取得
          this.targetFileName = result.file_name;
          // ファイルパスを取得
          this.csvFileUrl = result.file_url;
          // 対象ファイルをダウンロードする
          this.downloadCsv();
          this.$store.commit("setWaiting", false);
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              400: AlertBuilder.error("ダウンロードに失敗しました"),
              401: AlertBuilder.invalid(),
              403: AlertBuilder.error("権限がありません"),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    cancel() {
      this.$router.push("/product");
    },
    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
    /**
     * カレンダーの月間イベント更新
     */
    updateCalendarEvent(registrationDate) {
      this.applyDataToMonthlyArea(registrationDate);
    },
    /**
     * カレンダー表示用月間イベント取得処理
     */
    applyDataToMonthlyArea(date) {
      const { apiList, mapping } = this.haccpInfoRequest({
        date: new DateWrapper(date),
        daily: false,
        requireUserInfo: false,
      });

      this.$nextTick(() => {
        // APIのリクエスト
        this.$store.commit("setWaiting", true);
        Promise.all(apiList)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            this.events = {
              unloading: result[mapping.unloading].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              shipping: result[mapping.shipping].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              seawater: result[mapping.seawater].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
              worklog: result[mapping.worklog].record_list.map(
                (item) => new DateWrapper(item.record_date).format.systemDate
              ),
            };
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            if (error.status == 403) {
              this.errors.push(AlertBuilder.error("権限がありません"));
            } else {
              Api.resolve(error);
            }
          });
      });
    },
    haccpInfoRequest(parameter) {
      const date = parameter["date"] || new DateWrapper(Date.now());
      const daily = parameter["daily"] || false;
      const requireUserInfo = parameter["requireUserInfo"] || false;

      let requestDate = {
        year: date.format.build((d) => new String(d.date.y)),
        month: date.format.build((d) => new String(d.date.m02)),
      };
      if (daily) {
        requestDate["day"] = date.format.build((d) => new String(d.date.d02));
      }
      var apiList = [];
      var keys = [];
      if (requireUserInfo) {
        keys.push("user");
        apiList.push(
          Api.call("/admin/user", {
            purpose: "VIEW_HACCP",
          })
        );
      }

      keys.push(...["worklog", "shipping", "unloading", "seawater"]);
      apiList.push(
        ...[
          Api.call("/work/record", {
            uid: this.uid,
            record_type: "WORKLOG",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.uid,
            record_type: "SHIPPING",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.uid,
            record_type: "UNLOADING",
            record_date: requestDate,
          }),
          Api.call("/haccp/record", {
            uid: this.uid,
            record_type: "SEAWATER",
            record_date: requestDate,
          }),
        ]
      );
      return {
        apiList: apiList,
        mapping: keys.reduce((map, key, index) => {
          map[key] = index;
          return map;
        }, {}),
      };
    },
  },
};
</script>

<style scoped>
.title {
  background-color: #999999;
  color: white;
}
</style>
